
import { Button } from '@/components/ui/button';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* About Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/favicon/icon1.png" 
                alt="Development Society for Poor Logo" 
                className="h-12 w-auto mr-3"
              />
              <h3 className="text-xl font-bold">Development Society for Poor</h3>
            </div>
            <p className="text-white/90 mb-4 leading-relaxed">
              Development Society for Poor is a growing grass-roots organization working towards Sustainable 
              Livelihood, Quality Education, Health, Climate Change and Disaster Management among Tribal, Dalits, 
              Poor and Coastal fishing communities.
            </p>
            <div className="flex space-x-4 mt-4">
              <a href="#" className="hover:text-white/80 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white/80 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white/80 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="hover:text-white/80 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/" className="hover:underline hover:text-white/80">Home</a></li>
              <li><a href="/about" className="hover:underline hover:text-white/80">About Us</a></li>
              <li><a href="/services" className="hover:underline hover:text-white/80">Our Services</a></li>
              <li><a href="/gallery" className="hover:underline hover:text-white/80">Gallery</a></li>
              <li><a href="/contact" className="hover:underline hover:text-white/80">Contact Us</a></li>
              <li><a href="/donate" className="hover:underline hover:text-white/80">Donate</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 mt-1 mr-2 flex-shrink-0" />
                <span>Rentachintal Post & Mandal, palnadu 522 421, Andhra Pradesh, India</span>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 mr-2" />
                <a href="mailto:dsociety2005@gmail.com" className="hover:underline">dsociety2005@gmail.com</a>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 mr-2" />
                <a href="tel:+919985512014" className="hover:underline">+91 99855 12014</a>
              </li>
              <li className="flex items-center">
                <a href="tel:+918608807666" className="hover:underline ml-7">+91 86088 07666</a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-white/80 text-center md:text-left mb-4 md:mb-0">
              © {currentYear} Development Society for Poor. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="/privacy-policy" className="text-white/80 hover:text-white hover:underline">Privacy Policy</a>
              <a href="/terms" className="text-white/80 hover:text-white hover:underline">Terms of Service</a>
              <a href="/sitemap" className="text-white/80 hover:text-white hover:underline">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
